import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SalesDynamicsReport } from "@/features/reports/sales-dynamics-report";
import { ensureElementVisible } from "@/lib/route-guards";

const schema = z.object({
	yearFrom: z.coerce.number().int().min(2021).optional(),
	yearTo: z.coerce.number().int().min(2021).optional(),
	monthFrom: z.coerce.number().int().min(1).max(12).optional(),
	monthTo: z.coerce.number().int().min(1).max(12).optional(),
	metric: z
		.enum(["net", "gross", "quantity", "margin", "marginPct", "refund", "patientCount"])
		.optional(),
	scope: z.string().optional(),
	columnFilters: z.string().optional(),
	sortBy: z.string().optional(),
	sortDir: z.enum(["asc", "desc"]).optional(),
});

export const Route = createFileRoute("/_auth/raporty/dynamika-sprzedazy")({
	beforeLoad: async ({ context, location }) =>
		ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.dynamika-sprzedazy",
			location.pathname,
		),
	validateSearch: (search) => schema.parse(search),
	component: SalesDynamicsReport,
});
